<template>
    <div class="m-auto px-8 md:px-20 pb-8">
        <h1 class="pt-5 text-xl font-bold">Configurazioni delle business unit</h1>
        <p class="text-sm">Questa pagina è visibile solamente ad utenti con specifici permessi</p>

        <template v-if="buLabelFromFascePermission.length">
            <h2 class="py-5 font-bold">Fasce di ricavo</h2>

            <NextButton component="router-link" :to="{name:'FasceDiRicavo', params:{id :bu?.id || 0}}"
                        class="p-2 mb-3 mr-3"
                        v-for="bu in buLabelFromFascePermission">{{ bu?.nome }}
            </NextButton>
        </template>

        <template v-if="buLabelFromBilanciPermission.length">
            <h2 class="py-5 font-bold">Previsionale commerciale</h2>
            <NextButton component="router-link" :to="{name:'BilanciPrevisionaliBu',params:{id:bu?.id || 0}}"
                        class="p-2 mb-3 mr-3"
                        v-for="bu in buLabelFromBilanciPermission">{{ bu?.nome }}
            </NextButton>
        </template>
    </div>

    <div class="m-auto px-8 md:px-20 pb-8">
        <div class="py-5 text-2xl font-bold">
            Inserimento dati contabilità generali
        </div>

        <NextButton component="router-link" :to="{name:'ContabilitaAzienda', params:{id:a?.id || 0}}"
                    class="p-2 mb-3 mr-3"
                    v-for="a in aziende_contabilita">{{ a.nome }}
        </NextButton>
    </div>
</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import Loading from "@/components/Loading.vue";
import NextButton from "@/components/NextButton.vue";
import Field from "@/components/Field.vue";
import Alert from "@/components/Alert.vue";
import {mapState} from "vuex";
import businessUnits from "@/api/BusinessUnits";
import {aziendeGruppoManager} from "@/api/AziendeGruppo";

@Options({
    name: 'Configurazioni',
    components: {
        Alert,
        Field,
        NextButton,
        Loading
    },
    computed: {
        ...mapState(
            ['permissions']
        )
    },
})
export default class Configurazioni extends Vue {
    permissions!: any
    businessUnits = []
    buByLabel: any = {}
    aziende_contabilita: any[] = []

    created() {
        aziendeGruppoManager.fetchByContabilitaPermission().then((response: any) => {
            this.aziende_contabilita = response.data
        })
        businessUnits.list().then((response: any) => {
            this.businessUnits = response.data

            this.businessUnits.reduce((acc: any, bu: any) => {
                acc[bu.label.toString().toLowerCase()] = bu
                return acc
            }, this.buByLabel)
        })
    }

    get buLabelFromFascePermission() {
        let ret: any[] = []
        if (this.permissions) {
            for (let p in this.permissions) {
                const m = p.match('bu\.([a-zA-Z0-9]+)\.fasce_ricavo')
                if (m && m.length == 2) {
                    ret.push(this.buByLabel[m[1].toString().toLowerCase()])
                }
            }
        }
        return ret
    }

    get buLabelFromBilanciPermission() {
        let ret: any[] = []
        if (this.permissions) {
            for (let p in this.permissions) {
                const m = p.match('bu\.([a-zA-Z0-9]+)\.bilanci')
                if (m && m.length == 2) {
                    ret.push(this.buByLabel[m[1].toString().toLowerCase()])
                }
            }
        }
        return ret
    }


}

</script>
